import * as jQuery from 'jquery';
import * as React from 'react';
import { HSLColor } from 'react-color';
import { IsMobileDevice } from 'source/app/domain/Device/Helpers/IsMobile';
import { ColorPicker, GetColorString } from './ColorPicker/ColorPicker';
import { IsHtmlSelectorValid } from './Helpers/IsHtmlSelectorValid';
import { PatternSelector } from './PatternSelector/PatternSelector';
import { HtmlSelectorInput } from './SelectorInput/SelectorInput';

export function Texturizer() {
	const [ elementSelector, setElementSelector ] = React.useState('html');
	const [ patternName, setPatternName ] = React.useState('');
	const [ color, setColor ] = React.useState<HSLColor>({
		h: 0,
		s: 0,
		l: 0,
		a: 1
	});

	React.useEffect(() => SetPattern(elementSelector, patternName, color), [
		elementSelector,
		patternName,
		color
	]);

	return (
		<div id="applyTextureTool">
			<HtmlSelectorInput
				selection={elementSelector}
				setSelection={setElementSelector}
			/>
			<PatternSelector
				patternName={patternName}
				setPatternName={setPatternName}
			/>
			<ColorPicker color={color} setColor={setColor} />
		</div>
	);
}

function SetPattern(
	elementSelector: string,
	patternName: string,
	color: HSLColor
) {
	if (
		IsMobileDevice() &&
		IsHtmlSelectorValid(elementSelector) &&
		patternName !== ''
	) {
		jQuery(elementSelector)
			.css(
				'background-image',
				`url('/images/backgrounds/patterns/${patternName}.png')`
			)
			.css('background-color', GetColorString(color));
	}
}
